import React from 'react';
import appconfig from 'config/appconfig';
import {
  GotoAssistIcon,
  SeeItIcon,
  GotoIcon,
  GotoBlackMonochromeFaviconIcon,
  OpenVoiceIcon,
  GtcBlackVerticalIcon,
  GtrBlackVerticalIcon,
  GotoBlackIcon
} from '@getgo/chameleon-icons/react';
// Product settings and name references
const navProductSpecs = {
  g2ars: { class: <GotoAssistIcon />, product: appconfig.logMeInProducts.g2ars, productUrlRef: 'GoToAssist_url' },
  g2asd: { class: <GotoAssistIcon />, product: appconfig.logMeInProducts.g2asd, productUrlRef: 'ServiceDesk_url' },
  g2aseeit: { class: <SeeItIcon />, product: appconfig.logMeInProducts.g2aseeit, productUrlRef: 'Seeit_url' },
  g2m: { class: <GotoBlackMonochromeFaviconIcon />, product: appconfig.logMeInProducts.g2m, productUrlRef: 'GoToMeeting_url' },
  g2mApp: { class: <GotoBlackMonochromeFaviconIcon />, product: appconfig.logMeInProducts.g2m, productUrlRef: 'GoToMeetingApp_url' },
  g2mfree: { class: <GotoBlackMonochromeFaviconIcon />, product: appconfig.logMeInProducts.g2mfree, productUrlRef: 'GoToMeeting_url' },
  g2mfreeApp: { class: <GotoBlackMonochromeFaviconIcon />, product: appconfig.logMeInProducts.g2mfree, productUrlRef: 'GoToMeetingApp_url' },
  g2t: { class: <GotoIcon />, product: appconfig.logMeInProducts.g2t, productUrlRef: 'GoToTraining_url' },
  g2w: { class: <GotoIcon />, product: appconfig.logMeInProducts.g2w, productUrlRef: 'GoToWebinar_url' },
  g2p: { class: <GotoIcon />, product: appconfig.logMeInProducts.g2p, productUrlRef: 'GoToMyPc_url' },
  openvoice: {class: <OpenVoiceIcon />, product: appconfig.logMeInProducts.openvoice, productUrlRef: 'OpenVoice_url' },
  jive: { class: <GotoIcon />, product: appconfig.logMeInProducts.jive, productUrlRef: 'Jive_url' },
  hvoice: { class: <GotoBlackIcon />, product: appconfig.logMeInProducts.hvoice, productUrlRef: 'Jive_url' },
  gotoconnect: { class: <GtcBlackVerticalIcon />, product: appconfig.logMeInProducts.gotoconnect, productUrlRef: 'GoToConnect_url' },
  bold360: { class: <GotoBlackIcon />, product: appconfig.logMeInProducts.bold360, productUrlRef: 'Bold360_url' },
  gotoresolve: { class: <GtrBlackVerticalIcon />, product: appconfig.logMeInProducts.gotoresolve, productUrlRef: 'GoToResolve_url' },
  grasshopper: { class: <GotoBlackIcon />, product: appconfig.logMeInProducts.grasshopper, productUrlRef: 'Grasshopper_url' },
};
export default navProductSpecs;
